import React from 'react';
import styles from './WelcomeScreenNoMessage.scss';
import { BrandMomentCaptureIntro } from '@kaizen/draft-illustration';

export const WelcomeScreenNoMessage = () => {
  return (
    <div className={styles.WelcomeScreenNoMessageContainer}>
      <BrandMomentCaptureIntro autoplay loop isAnimated />
    </div>
  );
};
